export default __webpack_public_path__ + "static/media/PIANO RIFFY_1.47177358.wav";